import styled, {css} from 'styled-components';

import {colors} from 'theme';

export const BreadcrumbWrapper = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    font-size: 14px;
    color: ${colors.textSecondary};
`;

export const BreadCrumbItem = styled.div<{active?: boolean}>`
    cursor: pointer;

    &:hover {
        color: ${colors.brandPrimary};
    }

    ${(p) =>
        p.active &&
        css`
            color: ${colors.brandPrimary};
            font-weight: 700;
        `}
`;
